export const SECTIONS = {
	interests: "interests",
	passions: "passions",
	snapshots: "snapshots", // photos with captions
	nearby: "nearby",
	question_comments: "question_comments", // questions with explanations
	instagram: "instagram",
	important_questions: "important_questions", // questions you care about
	high_percentage: "high_percentage", // top matches
	trending_questions: "trending_questions",
	my_questions: "my_questions",
};

// only insert these if results come back from the server
export const SECTIONS_TO_HIDE_IF_EMPTY = {
	match_search_diet: "match_search_diet",
	match_search_religion: "match_search_religion",
	match_search_pets: "match_search_pets",
	match_search_height: "match_search_height",
	match_search_politics: "match_search_politics",
	match_search_smoking: "match_search_smoking",
	match_search_children: "match_search_children",
	match_search_drinking: "match_search_drinking",
	passions: "passions",
};

// layout sizes. NOTE these must be the same as the listings in ./consts.scss
export const SECTION_SIZING = {
	photoAndText: {
		width: 180,
		height: 276,
		gutter: 10,
	},
	multiPhoto: {
		width: 250,
		height: 306,
		gutter: 12,
	},
	photoWithCaption: {
		width: 200,
		height: 280,
		gutter: 14,
	},
	questionComment: {
		width: 297,
		height: 337,
		gutter: 10,
	},
	essayWithUserRow: {
		width: 319,
		height: 416,
		gutter: 12,
	},
	importantQuestionsHeader: {
		width: 912,
		height: 276,
		gutter: 14,
	},
};

export const SECTIONS_WITHOUT_PAGINATION_FADES = {
	[SECTIONS.question_comments]: true,
};

export const BODY_WIDTH = 912;

export const USER_THEMES = {
	blue: "blue",
	gray: "gray",
};

// how many people to get in each section
export const USERS_TO_FETCH = {
	[SECTIONS.interests]: 20,
	[SECTIONS.snapshots]: 19,
	[SECTIONS.nearby]: 20,
	[SECTIONS.question_comments]: 21,
	[SECTIONS.instagram]: 20,
	[SECTIONS.important_questions]: 20,
};

export const PHOTO_PROMPT_POSITION = 10;
export const INSTAGRAM_PROMPT_POSITION = 7;

// the inserted row goes after the content of this index row
export const QUESTION_ROW_INDEX = 1;
export const ADVERTISEMENT_ROW_INDEX = 2;

export const INTEREST_SEARCH_MAX_LENGTH = 100;

export const STATUSES = {
	loading: "loading",
	error: "error",
	success: "success",
};



// WEBPACK FOOTER //
// ./src/apps/discovery/util/consts.js